exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".greeting{position:fixed;top:0;left:0;width:100%;height:100%;display:flex;align-items:center;justify-content:center;text-align:center;flex-direction:column;pointer-events:none}.greeting img{margin:0 auto;position:relative}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3ed189cf","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Hello.vue
// module id = 54
// module chunks = 0